<template>
    <div id="modalAddModel" class="modal fade"  role="dialog">
        <div class="modal-dialog modal-dialog-centered" role="document" style="min-width: 50rem">
            <div class="modal-content">
                <div class="modal-container">
                    <div class="modal-header-custom">
                        <div>
                            <h5 class="modal-title-custom">{{modalStep == 0 ? 'Add Unit Models' : 'Confirm Selection'}}</h5>
                            <p class="modal-subtitle">{{modalStep == 0 ? 'Select one or more unit models to add to this part.' : 'Please review your selection below.'}}</p>
                        </div>
                        <button class="close-button" @click="closeModal">×</button>
                    </div>

                    <div class="modal-body-custom" v-if="modalStep == 0">
                        <div class="select-models-label">Select Models</div>
                    
                        <div class="search-input-wrapper">
                            <i class="fas fa-search search-icon"></i>
                            <input 
                                type="text" 
                                class="search-input" 
                                v-model="searchModel"
                                placeholder="Search models..."
                            >
                            <span class="clear-icon" v-if="searchModel" @click="searchModel = ''">×</span>
                        </div>
                
                        <div class="models-list" ref="modelsList">
                            <div 
                                v-for="model in modelOptions" 
                                :key="model.itemCode" 
                                class="model-item"
                                @click="toggleModel(model)"
                            >
                                <input 
                                    type="checkbox" 
                                    class="model-checkbox" 
                                    :checked="selectedModels.find(item => item.itemCode == model.itemCode)"
                                    @click.stop="toggleModel(model)"
                                >
                                <span class="model-name">{{ model.itemName }}</span>
                            </div>
                            <div class="models-list btn-load-more" v-if="!loadingSearchModel && modelOptions.length > 0 && hasMoreData" @click.stop="loadMoreModels">
                                <span class="btn-load-more">Load more models</span>
                            </div>

                            <!-- ✅ Sentinel element untuk trigger load more -->
                            <!-- <div ref="sentinel" style="height: 1px;"></div>  -->
                            <div class="models-list" v-if="loadingSearchModel">
                                Preparing data for you...
                            </div>
                            <div class="models-list" ref="modelsList" v-if="!loadingSearchModel && modelOptions.length == 0">
                                No Data
                            </div>
                        </div>
                         
                    </div>

                    <div class="modal-body-custom" v-if="modalStep == 1">
                        <div class="mb-3">
                            <div class="font-weight-bold mb-3">Part Info</div>
                            <div class="item-card">
                                <div class="row align-items-center">
                                    <div class="col-md-2">
                                        <div class="item-label">Item Code</div>
                                        <div class="item-value">{{ this.$route.params.id }}</div>
                                    </div>
                                    <div class="col-md-1 text-center d-none d-md-block">
                                        <div style="width: 1px; height: 60px; background-color: #e0e0e0; margin: 0 auto;"></div>
                                    </div>
                                    <div class="col-md-9">
                                        <div class="item-label">Part Name</div>
                                        <div class="item-value">{{`${this.$route.query.itemGroup} - ${this.$route.query.itemName}`}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Selected Models -->
                        <div class="selected-models-title">Selected Models ({{ selectedModels.length }})</div>
                        <div v-for="value in selectedModels" :key="value.itemCode">
                            <div class="model-item-check">
                                <div class="check-icon">✓</div>
                                <div class="model-name">{{value.itemName}}</div>
                            </div>
                        </div>
                       
                    </div>

                    <div class="modal-footer-custom" v-if="modalStep == 0">
                        <button class="btn-cancel" @click="closeModal">Cancel</button>
                        <button 
                            class="btn-add-models" 
                            :disabled="selectedModels.length == 0"
                            @click="toNextStep"
                        >
                            Add Models
                        </button>
                    </div>

                    <div class="modal-footer-custom" v-if="modalStep == 1">
                        <button class="btn-cancel" @click="toPreviousStep">Check Again</button>
                        <button 
                            class="btn-add-models" 
                            :disabled="selectedModels.length == 0"
                            @click="addModels"
                        >
                            Confirm & Add
                        </button>
                    </div>
                </div> 
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'modalAddModel',
    components: {},
    props : ['dataPart'],
    data () {
        return {
            loadingAddProcess : false,
            loadingSearchModel : false,
            modalStep : 0,
            selectedModels : [],
            searchModel: '',
            modelOptions : [],
            debounceTimer: null,
            currentPage : 1,
            totalPage : 0,
            hasMoreData : true,
            observer : null,
        }
    },
    watch: {
        searchModel(newValue) {
            this.currentPage = 1;
            this.modelOptions = [];
            this.hasMoreData = true;
            // Clear timer sebelumnya
            clearTimeout(this.debounceTimer);
            // Set timer baru, tunggu 500ms setelah user berhenti mengetik
                this.debounceTimer = setTimeout(() => {
                this.getModelOptionList();
            }, 1500); // 2000ms delay
        }
    },
    methods : {
        loadMoreModels() {
            this.currentPage++;
            this.getModelOptionList()
        },
        toNextStep(){
            this.modalStep += 1;
        },
        toPreviousStep() {
            this.modalStep -= 1;
        },
        // setupIntersectionObserver() {
        //     const options = {
        //         root: this.$refs.modelsList,
        //         threshold: 0.1
        //     };
            
        //     this.observer = new IntersectionObserver((entries) => {
        //         entries.forEach(entry => {
        //             if (entry.isIntersecting && !this.loadingSearchModel && this.hasMoreData) {
        //                 this.currentPage++;
        //                 this.getModelOptionList();
        //             }
        //         });
        //     }, options);
            
        //     if (this.$refs.sentinel) {
        //         this.observer.observe(this.$refs.sentinel);
        //     }
        // },
        toggleModel(model){
            if(!this.selectedModels.find(item => item.itemCode == model.itemCode)) {
                this.selectedModels.push(model)
            } else {
                let indexLocation = this.selectedModels.findIndex (item => item.itemCode == model.itemCode)
                this.selectedModels.splice(indexLocation, 1);
            }
        },
        closeModal(){
            $("#modalAddModel").modal('hide')
            this.modalStep = 0
            this.selectedModels =[];
        },
        addModels() {
            this.loadingAddProcess = true
            let partCompatibilities = []
            this.selectedModels.forEach(model => {
                const {itemName, itemCode, itemGroup,itemCodes} = model
                partCompatibilities.push({
                    itemCodes,
                    itemCode,
                    itemName,
                    itemGroup
                })
            })
            this.$http.post(
                process.env.EDIT_PART_COMPABILITIES,
                {
                    action: "add",
                    itemCode: this.dataPart.itemCode, 
                    partCompatibilities: partCompatibilities
                },
                {
                    headers: {
                        "Asani-Token": localStorage.getItem("jwt"),
                    },
                }
            )
            .then((response) => {
                if (response.data.status !== 200) {
                    swal("Sorry", response.data.message, "error", {
                        button: "Ok",
                    });
                } else if (response.data.status == 200) {
                    swal("Success", response.data.message, "success", {
                        button: "Ok",
                    }).then(() => {
                    window.location.reload()    
                    });
                }
                this.loadingAddProcess = false;
            })
            .catch((error) => {
                swal("Sorry", error.message, "error", {
                    button: "Ok",
                }).then((v) => {
                    if (error.response.data.status == 401) {
                        this.handleLogout();
                    }
                });
            });
        },
        getModelOptionList() {
            this.loadingSearchModel = true;
            this.$http.get(
                process.env.GET_PART_COMPABILITY_MODELS+`?itemName=${this.searchModel}&page=${this.currentPage}&itemPerPage=20`,
                {
                    headers: {
                        "Asani-Token": localStorage.getItem("jwt"),
                    },
                }
            )
            .then((response) => {
                if (response.data.status !== 200) {
                    swal("Sorry", response.data.message, "error", {
                        button: "Ok",
                    });
                } else if (response.data.status == 200) {
                    const {data, totalPage} = response.data.content
                    const newData = data || []
                    this.totalPage = totalPage

                    if (this.currentPage === 1) {
                        this.modelOptions = newData;
                    } else {
                        this.modelOptions = [...this.modelOptions, ...newData];
                    }

                    if (newData.length === 0 || newData.length < 10 || this.currentPage == this.totalPage) {
                        this.hasMoreData = false;
                    }
                }
                this.loadingSearchModel = false;
            })
            .catch((error) => {
                swal("Sorry", error.message, "error", {
                    button: "Ok",
                }).then((v) => {
                    if (error.response.data.status == 401) {
                        this.handleLogout();
                        this.loadingSearchModel = false;
                    }
                });
                this.loadingSearchModel = false;
            });
        }
        
    },
    // mounted() {
    //     this.$nextTick(() => {
    //         this.setupIntersectionObserver();
    //     });
    // },
    beforeDestroy() {
        // Cleanup timer saat component destroy
        clearTimeout(this.debounceTimer);
    },
    created () {
        this.getModelOptionList()
    }
}
</script>
<style scoped>
    .btn-load-more {
        float: right;
        color : #247FEC; 
        cursor: pointer;
        align-items: end;
    }

    .btn-load-more:hover{
        background-color: #EFF6FF;
    }
   
    .selected-models-title {
        font-size: 14px;
        font-weight: 600;
        margin-bottom: 15px;
        color: #212529;
    }
    .model-item-check {
        background-color: #EFF6FF;
        border-radius: 6px;
        border: 1px solid;
        border-color: #BEDBFF;
        padding: 12px 15px;
        margin-bottom: 10px;
        display: flex;  
        align-items: center;
        gap: 10px;
    }
        
    .check-icon {
        width: 20px;
        height: 20px;
        background-color: #007bff;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
        font-size: 12px;
        flex-shrink: 0;
    }
        
    .model-name {
        font-size: 14px;
        color: #212529;
    }
        
.item-card {
    background: white;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    padding: 20px;
    max-width: 900px;
    margin: 0 auto;
}
.item-label {
  color: #6c757d;
  font-size: 14px;
  margin-bottom: 5px;
}
.item-value {
  color: #212529;
  font-size: 16px;
  font-weight: 400;
}

.modal-container {
    background: white;
    border-radius: 8px;
    width: 100%;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
    animation: slideDown 0.3s ease;
}
    @keyframes slideDown {
      from {
        opacity: 0;
        transform: translateY(-50px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }
    .modal-header-custom {
      padding: 20px 24px;
      border-bottom: 1px solid #e9ecef;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
    }
    .modal-title-custom {
      font-size: 20px;
      font-weight: 600;
      color: #212529;
      margin: 0;
    }
    .modal-subtitle {
      font-size: 14px;
      color: #6c757d;
      margin-top: 5px;
    }
    .close-button {
      background: none;
      border: none;
      font-size: 24px;
      color: #6c757d;
      cursor: pointer;
      padding: 0;
      width: 30px;
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .close-button:hover {
      color: #212529;
    }
    .modal-body-custom {
      padding: 20px 24px;
    }
    .select-models-label {
      font-size: 14px;
      font-weight: 600;
      color: #212529;
      margin-bottom: 12px;
    }
    .search-input-wrapper {
      position: relative;
      margin-bottom: 16px;
    }
    .search-input {
      width: 100%;
      padding: 10px 40px 10px 35px;
      border: 1px solid #ced4da;
      border-radius: 6px;
      font-size: 14px;
    }
    .search-input:focus {
      outline: none;
      border-color: #80bdff;
      box-shadow: 0 0 0 0.2rem rgba(0,123,255,.25);
    }
    .search-icon {
      position: absolute;
      left: 12px;
      top: 50%;
      transform: translateY(-50%);
      color: #6c757d;
      font-size: 14px;
    }
    .clear-icon {
      position: absolute;
      right: 12px;
      top: 50%;
      transform: translateY(-50%);
      color: #6c757d;
      cursor: pointer;
      font-size: 18px;
    }
    .clear-icon:hover {
      color: #212529;
    }
    .models-list {
      max-height: 250px;
      overflow-y: auto;
      border: 1px solid #dee2e6;
      border-radius: 6px;
      padding: 8px;
    }
    .model-item {
      display: flex;
      align-items: center;
      padding: 12px;
      border-radius: 4px;
      cursor: pointer;
      transition: background-color 0.2s;
    }
    .model-item:hover {
      background-color: #f8f9fa;
    }
    .model-checkbox {
      width: 18px;
      height: 18px;
      margin-right: 12px;
      cursor: pointer;
    }
    .model-name {
      font-size: 14px;
      color: #212529;
      flex: 1;
    }
    .info-badge {
      background-color: #17a2b8;
      color: white;
      width: 24px;
      height: 24px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      margin-left: 8px;
    }
    .modal-footer-custom {
      padding: 16px 24px;
      border-top: 1px solid #e9ecef;
      display: flex;
      justify-content: flex-end;
      gap: 12px;
    }
    .btn-cancel {
      background-color: white;
      border: 1px solid #ced4da;
      color: #495057;
      padding: 8px 20px;
      border-radius: 4px;
      cursor: pointer;
      font-size: 14px;
    }
    .btn-cancel:hover {
      background-color: #f8f9fa;
    }
    .btn-add-models {
      background-color: #007bff;
      border: none;
      color: white;
      padding: 8px 20px;
      border-radius: 4px;
      cursor: pointer;
      font-size: 14px;
    }
    .btn-add-models:hover {
      background-color: #0056b3;
    }
    .btn-add-models:disabled {
      background-color: #b3d9ff;
      cursor: not-allowed;
      opacity: 0.6;
    }
 </style>


// WEBPACK FOOTER //
// src/components/Catalog/Components/ModalAddModel.vue